import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedFetch } from './useAuth'

export type AccessInfo = { role: 'viewer'|'editor'|'moderator'|'owner'|'none'; canWrite: boolean }
export type AccessInfoWithSource = AccessInfo & { source: 'auth' | 'link' }

export function useDiagramAccess(diagramId?: string) {
  const fetcher = useAuthenticatedFetch()
  const enabled = Boolean(diagramId)

  return useQuery<AccessInfoWithSource>({
    queryKey: ['diagram', diagramId, 'access'],
    enabled,
    queryFn: async () => {
      // Try auth-backed access first
      let j: any | null = null
      try {
        const r = await fetcher(`/api/diagrams/${diagramId}/access`)
        if (r.ok) {
          j = await r.json()
          if (j && j.role && j.role !== 'none') return { ...(j as AccessInfo), source: 'auth' }
        }
      } catch {}
      // Always attempt link-based access (HttpOnly cookie cannot be read from JS)
      try {
        const r2 = await fetch(`/api/link/diagrams/${diagramId}/access`, { credentials: 'include' })
        if (r2.ok) {
          const j2 = await r2.json()
          if (j2 && j2.role && j2.role !== 'none') {
            return { ...(j2 as AccessInfo), source: 'link' }
          }
        }
      } catch {}
      // Fallback to none
      return { role: 'none', canWrite: false, source: 'auth' }
    },
    staleTime: 30_000,
  })
}

